import { useTranslation } from "react-i18next";

import { PanelStackContext } from "@lib/logic";
import { type AreaWithSensorInfo, getFloorHasMap, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { LocationBasedServices } from "../../../../organisms/LocationBasedServices";
import { useHaNLayoutMode } from "../../state/layout/useHaNLayoutMode";
import { ControlsSection } from "../controls/ControlsSection";
import { HaNDetailsPage } from "../HaNDetailsPage";
import { AreaActivityTypes } from "./components/AreaActivityTypes";
import { AreaAvailability } from "./components/AreaAvailability";
import { AreaConnections } from "./components/AreaConnections";
import { AreaDeskAmenities } from "./components/AreaDeskAmenities";
import { AreaMapPreview } from "./components/AreaMapPreview";
import { AreaSummary } from "./components/AreaSummary";

export const WorkspaceInfoPage = ({ area }: { area: AreaWithSensorInfo }) => {
  const { t } = useTranslation();
  const { push } = useRequiredContext(PanelStackContext);
  const layoutMode = useHaNLayoutMode();
  const floorHasMap = useAppSelector(getFloorHasMap(area.floorId));

  return (
    <HaNDetailsPage title={t("workplace:Area")}>
      <section className="flex flex-col gap-8 px-5 py-6">
        <AreaSummary area={area} />

        <AreaAvailability
          area={area}
          onLearnMorePress={() => push("occupancyInfo")}
        />

        <AreaActivityTypes activityTypes={area.activityTypes} />

        <AreaDeskAmenities deskAmenities={area.deskAmenities} />

        <ControlsSection nodeId={area.id} />

        {floorHasMap && layoutMode === "mobile" && <AreaMapPreview area={area} />}

        <AreaConnections areaId={area.id} />

        <LocationBasedServices
          buildingId={area.buildingId}
          locationType="Area"
          locationName={area.name}
        />
      </section>
    </HaNDetailsPage>
  );
};
